import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/stages",
        name: "stages",
        component: () => import("@/components/stages/_Stages.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewStagesUI,
            breadcrumbs: {
                icon: "stages-icon",
                paths: []
            },
            title: "stage.title"
        }
    },
    {
        path: "/stages/:stageId/update",
        name: "updateStage",
        component: () => import("@/components/stages/_StageForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateStage,
            breadcrumbs: {
                icon: "stages-icon",
                paths: [
                    ["/stages", i18n.t("stage.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/stages/create",
        name: "createStage",
        component: () => import("@/components/stages/_StageForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateStage,
            breadcrumbs: {
                icon: "stages-icon",
                paths: [
                    ["/stages", i18n.t("stage.title")]
                ]
            },
            title: "stage.createNewStage"
        },
        props: true
    }
];
